import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
    modalBox: {
        position: 'absolute',
        top: 330,
        right: 10,
        width: 500,
        backgroundColor: 'white',
        border: '2px solid #538000',
        padding: 10,
        overflowY: 'auto',
        height: 500,
    },
    modalHead: {
        flex: '0 0 auto'
    },
    closeButton: {
        position: "absolute",
        right: 8,
        top: 8,
        color: "black",
        padding: 0
    },
    modalContent: {
        margin: 10,
    },
    errorMessageText: {
        fontSize: "inherit",
        color: "red",
        marginTop: 250,
        textAlign: "center"   
    }
});
